<style lang="less">
@import '../main.less';
</style>

<template>
    <div ref="scrollCon" @mousewheel="handlescroll" class="tags-outer-scroll-con">
        <div class="close-all-tag-con">
            <Dropdown transfer @on-click="handleTagsOption">
                <Button size="small" type="primary">
                    标签选项
                    <Icon type="arrow-down-b"></Icon>
                </Button>
                <DropdownMenu slot="list">
                    <DropdownItem name="clearAll">关闭所有</DropdownItem>
                    <DropdownItem name="clearOthers">关闭其他</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <div ref="scrollBody" class="tags-inner-scroll-body" :style="{left: tagBodyLeft + 'px'}">
            <transition-group name="taglist-moving-animation">
                <Tag 
                    type="dot"
                    v-for="(item, index) in pageTagsList" 
                    ref="tagsPageOpened"
                    :key="item.name" 
                    :name="item.name" 
                    @on-close="closePage"
                    @click.native="linkTo(item)"
                    :closable="item.name !== 'home_index'"
                    :color="item.children?(item.children[0].name===currentPageName?'blue':'default'):(item.name===currentPageName?'blue':'default')"
                >{{ itemTitle(item) }}</Tag>
            </transition-group>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
Vue.use(VueI18n);
export default {
    name: 'tagsPageOpened',
    data() {
        return {
            currentPageName: this.$route.name,
            tagBodyLeft: 0,
            currentScrollBodyWidth: 0,
            refsTag: [],
            tagsCount: 1
        };
    },
    props: {
        pageTagsList: Array
    },
    computed: {
        title() {
            return this.$store.state.currentTitle;
        },
        tagsList() {
            return this.$store.state.pageOpenedList;
        }
    },
    methods: {
        itemTitle(item) {
             let _title = ''
            if (typeof item.title === 'object') {
                return this.$t(item.title.i18n);
            } else {
                // if(item.name == 'main-order-number'){
                //      _title = item.argu.orderNumber;
                // }else{
                    _title = item.title
                // }
                return _title;
            }
        },
        closePage(event, name) {
            this.$store.commit('removeTag', name);
            this.$store.commit('closePage', name);
            // 关闭主提订单详情,清空所有的子tag
            if(name == 'main-order-number'){ this.$store.commit("mainOrderNumber/cleanTag");}
            let pageOpenedList = this.$store.state.pageOpenedList;
            localStorage.pageOpenedList = JSON.stringify(pageOpenedList);
            if (this.currentPageName === name) {
                let pageObj = null;
                if (pageOpenedList.length > 1) {
                    pageObj = pageOpenedList[1];
                } else {
                    pageObj = pageOpenedList[0];
                }
                this.linkTo(pageObj);
            }
        },
        linkTo(item) {
            let routerObj = {};
            routerObj.name = item.name;
            if (item.argu) {
                routerObj.params = item.argu;
            }
            if (item.query) {
                routerObj.query = item.query;
            }
            // 单独处理主提订单详情页面
            if(routerObj.name == 'main-order-number'){
                _hmt.push(['_trackEvent', 'PC订单中心', '主提订单详情', Cookies.get('user')])
                if(this.$store.state.mainOrderNumber.blNo ){
                 this.$router.push({name: routerObj.name, params: { orderNumber: this.$store.state.mainOrderNumber.blNo }});
                }else{
                    this.$router.push(routerObj);
                }
            }else{
               this.$router.push(routerObj);
            }
        },
        handlescroll(e) {
            let left = 0;
            if (e.wheelDelta > 0) {
                left = Math.min(0, this.tagBodyLeft + e.wheelDelta);
            } else {
                if (
                    this.$refs.scrollCon.offsetWidth - 100 <
                    this.$refs.scrollBody.offsetWidth
                ) {
                    if (
                        this.tagBodyLeft <
                        -(
                            this.$refs.scrollBody.offsetWidth -
                            this.$refs.scrollCon.offsetWidth +
                            100
                        )
                    ) {
                        left = this.tagBodyLeft;
                    } else {
                        left = Math.max(
                            this.tagBodyLeft + e.wheelDelta,
                            this.$refs.scrollCon.offsetWidth -
                                this.$refs.scrollBody.offsetWidth -
                                100
                        );
                    }
                } else {
                    this.tagBodyLeft = 0;
                }
            }
            this.tagBodyLeft = left;
        },
        handleTagsOption(type) {
            if (type === 'clearAll') {
                this.$store.commit('clearAllTags');
            } else {
                this.$store.commit('clearOtherTags', this);
            }
            this.tagBodyLeft = 0;
        },
        moveToView(tag) {
            if (tag.offsetLeft < -this.tagBodyLeft) {
                // 标签在可视区域左侧
                this.tagBodyLeft = -tag.offsetLeft + 10;
            } else if (
                tag.offsetLeft + 10 > -this.tagBodyLeft &&
                tag.offsetLeft + tag.offsetWidth <
                    -this.tagBodyLeft + this.$refs.scrollCon.offsetWidth - 100
            ) {
                // 标签在可视区域
            } else {
                // 标签在可视区域右侧
                this.tagBodyLeft = -(
                    tag.offsetLeft -
                    (this.$refs.scrollCon.offsetWidth - 100 - tag.offsetWidth) +
                    20
                );
            }
        }
    },
    mounted() {
        this.refsTag = this.$refs.tagsPageOpened;
        setTimeout(() => {
            this.refsTag &&
                this.refsTag.forEach((item, index) => {
                    if (this.$route.name === item.name) {
                        let tag = this.refsTag[index].$el;
                        this.moveToView(tag);
                    }
                });
        }, 1); // 这里不设定时器就会有偏移bug
        this.tagsCount = this.tagsList.length;
    },
    watch: {
        $route(to) {
            this.currentPageName = to.name;
            this.$nextTick(() => {
                this.refsTag &&
                    this.refsTag.forEach((item, index) => {
                        if (to.name === item.name) {
                            let tag = this.refsTag[index].$el;
                            this.moveToView(tag);
                        }
                    });
            });
            this.tagsCount = this.tagsList.length;
        }
    },
};
</script>



// WEBPACK FOOTER //
// tagsPageOpened.vue?0ae8732f